var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-card"},[(_vm.hasLeftColumnSlot)?_c('div',{staticClass:"login-card__left-column"},[_vm._t("left-column")],2):_vm._e(),_vm._v(" "),(_vm.hasRightColumnSlot)?_c('div',{staticClass:"login-card__right-column"},[_vm._t("right-column")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }